import { Observation } from './observation';

export class ObservationPlot {
  constructor(public leafletId: number, public observation: Observation) {}
}
